<template>
  <div>
    <px-view-header title="Minha resposta" :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1"
               icon
               x-large
               color="primary"
               @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>

    <div v-if="loading">
      <px-circular-loading/>
    </div>

    <v-card v-if="!loading && resposta">
      <v-card-text>
        <div class="text--primary">
          <v-row dense>
            <v-col cols="12" sm="4">
              <span class="caption font-weight-bold">Valor de frete</span>
              <div>
                {{ resposta.total | currency }}
              </div>
            </v-col>
            <v-col cols="12" sm="4">
              <span class="caption font-weight-bold">ICMS</span>
              <div>
                <px-imposto :imposto="resposta" tipo="ICMS"/>
              </div>
            </v-col>
            <v-col cols="12" sm="4">
              <span class="caption font-weight-bold">Valor sem ICMS</span>
              <div>
                {{ resposta.valorFrete | currency }}
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4">
              <span class="caption font-weight-bold">Prazo de entrega</span>
              <div>
                {{ resposta.prazoEntrega }} dias corridos
              </div>
            </v-col>
            <v-col cols="12" sm="4">
              <span class="caption font-weight-bold">Forma de pagamento</span>
              <div>
                <px-forma-pagamento :forma-pagamento="resposta.formaPagamento"
                                    :prazo-pagamento="resposta.prazoPagamento"/>
              </div>
            </v-col>
            <v-col cols="12" sm="4">
              <span class="caption font-weight-bold">Válido até</span>
              <div>
                {{ resposta.validade | date | naoInformado }}
              </div>
            </v-col>
          </v-row>
          <v-divider class="mt-3"/>
          <v-row dense class="mt-3">
            <v-col cols="12" sm="6">
              <span class="caption font-weight-bold">Observação</span>
              <div class="large-text">
                {{ resposta.observacao | naoInformado }}
              </div>
            </v-col>
            <v-col cols="12" sm="6">
              <span class="caption font-weight-bold">Arquivos</span>
              <div v-if="resposta.arquivos.length">
                <px-anexo-chip :files="resposta.arquivos"
                               :download-base-path="downloadPath"/>
              </div>
              <div v-else>
                Nenhum arquivo informado
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>

  </div>
</template>

<script>
import CotacaoService from '../../cotacoes-service';

export default {
  data() {
    return {
      id: this.$route.params.id,
      idResposta: this.$route.params.idResposta,
      loading: false,
      resposta: null,
      breadcrumbs: [
        { text: 'Negócios' },
        { text: 'Cotações' },
      ],
    };
  },
  computed: {
    downloadPath() {
      return `transportador/respostas-fretes/${this.idResposta}/file`;
    },
  },
  methods: {
    onClickBack() {
      this.$router.push({
        name: 'main.cotacoes.detalhes',
        params: { id: this.id },
      });
    },
    getResposta() {
      this.loading = true;
      CotacaoService.getResposta(this.idResposta)
        .then(({ data }) => {
          this.resposta = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getResposta();
  },
};
</script>
